import type { Background, BorderColors, Color } from './RadioButton.h'

import { styled } from '@linaria/react'
import { TextBoxSC } from 'atoms/TextBox'
import { CORNERS, SHADOW } from 'vars/index'

export const Checkmark = styled.span<{
  borderColor: BorderColors
  background: Background
  colorDefault: Color
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: ${CORNERS.CORNERS_10};
  border: 1px solid ${({ borderColor }) => `var(${borderColor})`};
  background: ${({ background }) => `var(${background})`};

  &:after {
    content: '';
    position: absolute;
    display: none;
    top: 4px;
    left: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ colorDefault }) => `var(${colorDefault})`};
    box-shadow: var(${SHADOW.NORMAL});
  }
`

export const Label = styled.label<{
  backgroundHovered?: Background
  borderColorHovered: BorderColors
  borderColorChecked: BorderColors
  backgroundChecked: Background
  backgroundDisabled: Background
  borderColorDisabled: BorderColors
  colorDisabled: Color
}>`
  display: block;
  position: relative;
  cursor: pointer;
  width: fit-content;

  ${TextBoxSC} {
    padding-left: 29px;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    top: 0;
  }

  &:hover input ~ ${Checkmark}, &.hover input ~ ${Checkmark} {
    background: ${({ backgroundHovered }) => `var(${backgroundHovered})`};
    border-color: ${({ borderColorHovered }) => `var(${borderColorHovered})`};
  }

  &:hover input:checked ~ ${Checkmark}, &.hover input:checked ~ ${Checkmark} {
    border: 1px solid
      ${({ borderColorChecked }) => `var(${borderColorChecked})`};

    &:after {
      top: 3px;
      left: 3px;
    }
  }

  input:checked ~ ${Checkmark} {
    background: ${({ backgroundChecked }) => `var(${backgroundChecked})`};
    border: none;

    &:after {
      display: block;
    }
  }

  input:disabled ~ ${Checkmark} {
    background: ${({ backgroundDisabled }) => `var(${backgroundDisabled})`};
    border-color: ${({ borderColorDisabled }) => `var(${borderColorDisabled})`};
    cursor: not-allowed;
  }

  input:checked:disabled ~ ${Checkmark} {
    background: ${({ backgroundDisabled }) => `var(${backgroundDisabled})`};
    border: none;
    cursor: not-allowed;

    &:after {
      display: block;
      background: ${({ colorDisabled }) => `var(${colorDisabled})`};
      top: 4px;
      left: 4px;
    }
  }
`
